// extracted by mini-css-extract-plugin
module.exports = {"strong":"Leaf_strong__3AP09"};